// src/hooks/getBaseUrl.ts
import { getServiceForTenant, getServicePath, getTenantHost, resolveTenantId } from "./resolveTenantId";

/**
 * 客户端按当前域名解析机构 id, 与服务端 getIdFromHost 一致;
 * 本地调试时 URL 上的 ?debugId=xxx 优先 (page.tsx 服务端同样识别该参数)。
 * 服务端调用时无域名信息, 回退为 jigou。
 */
export function getTenantId(): string {
  if (typeof window === "undefined") {
    return 'jigou';
  }
  const debugId = new URLSearchParams(window.location.search).get('debugId');
  return debugId || resolveTenantId(window.location.hostname);
}

/** 机构后端服务的绝对地址, 如 https://jigou.wenkoo.com.cn/wk-api/wenkoo-tenant */
export async function getBaseUrl(prefix?: string): Promise<string> {
  const tenantId = prefix || getTenantId();
  return `https://${getTenantHost(tenantId)}${getServicePath(getServiceForTenant(tenantId))}`;
}
